import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectProduct, setVizLoading } from '../../../../store/visualizerSlice';
import ProductList from '../../ProductList/ProductList';
import StepNavigation from '../../StepNavigation/StepNavigation';
import styles from './ExtTrim.module.css';

export default function ExtTrim({ 
    surfaceName = 'Trim', 
    stepIndex,
    room = '',
    onViewAllApplied, 
    onNext, 
    onPrevious 
}) {
    const dispatch = useDispatch();
    const stepSelections = useSelector(state => state.visualizer.stepSelections);
    const [selectedProduct, setSelectedProduct] = useState(null);

    // Selection key: StepName_Room
    const selectionKey = `ExtTrim_${room}`;

    // Restore selection from Redux on mount
    useEffect(() => {
        const savedSelection = stepSelections[selectionKey];
        if (savedSelection?.product) {
            setSelectedProduct(savedSelection.product);
        }
    }, [stepSelections, selectionKey]);

    const handleProductSelect = (product) => {
        setSelectedProduct(product);
        
        console.log('ExtTrim - Product selected:', product.color || product.name);
        console.log('ExtTrim - Applying to surface:', surfaceName);
        
        dispatch(selectProduct({
            product,
            surfaceName,
            stepIndex,
            selectionKey
        }));
        
        const chamViz = document.getElementById('chamViz');
        if (!chamViz) {
            console.error('ExtTrim - chamViz element not found');
            return;
        }

        if (!product.id) {
            console.error('ExtTrim - Product has no ID');
            return;
        }

        console.log('ExtTrim - Applying product ID:', product.id);
        dispatch(setVizLoading(true));
        
        chamViz.applyByFilter(
            product.id,
            "",
            function(newSel) {
                if (this.name === surfaceName) {
                    return newSel;
                }
                return this.sel;
            },
            true
        );
    };

    const handleViewAllApplied = () => {
        if (onViewAllApplied) {
            onViewAllApplied();
        }
    };

    return (
        <div className={styles.container}>
            <StepNavigation
                title="Trim"
                onNext={onNext}
                onPrevious={onPrevious}
                onViewAllApplied={handleViewAllApplied}
            />

            <div className={styles.productListContainer}>
                <ProductList
                    seriesId="9746"
                    thumbSize="256"
                    onProductSelect={handleProductSelect}
                    titleAttribute="color"
                    descriptionAttribute="name"
                    gridClassName={styles.productGrid}
                    selectedId={selectedProduct?.id}
                />
            </div>
        </div>
    );
}

ExtTrim.propTypes = {
    surfaceName: PropTypes.string,
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
